/* Candle product galleries (Berenice, 2026-11-01). Thumbnails under the main photo
   (snippets/wp-candle-gallery.liquid) show a photo or play a video in the main frame.
   The frame takes the shape of whatever it shows, so there are no empty bands.
   Videos start as soon as they are tapped and loop, muted, with no player controls.
   Works alongside the variant photo swap in sections/wp-candle-product-preview.liquid:
   both set img.dataset.want, so the latest request wins. */
(() => {
  const root = document.getElementById('wp-candle-preview');
  if (!root) return;

  const frameOf = (thumbs) => thumbs.closest('.gallery').querySelector('.gframe');

  const start = (video) => {
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  };

  const videoOf = (frame) => {
    let video = frame.querySelector('video.gvideo');
    if (!video) {
      video = document.createElement('video');
      video.className = 'gvideo';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = 'auto';
      ['muted', 'loop', 'autoplay', 'playsinline', 'webkit-playsinline', 'disablepictureinpicture', 'disableremoteplayback']
        .forEach((name) => video.setAttribute(name, ''));
      video.setAttribute('x-webkit-airplay', 'deny');
      video.hidden = true;
      // No controls. If the browser ever holds playback back, a tap or the first data starts it.
      video.addEventListener('click', () => { if (video.paused) start(video); });
      video.addEventListener('canplay', () => { if (!video.hidden && video.paused) start(video); });
      frame.appendChild(video);
    }
    return video;
  };

  const setActive = (thumbs, button) => {
    thumbs.querySelectorAll('.thumb').forEach((thumb) => {
      const on = thumb === button;
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  // Remember the product photo's own size and alt before anything changes them.
  const remember = (img) => {
    if (!img.dataset.mainW) {
      img.dataset.mainW = img.getAttribute('width') || '';
      img.dataset.mainH = img.getAttribute('height') || '';
    }
    if (!img.dataset.mainAlt) img.dataset.mainAlt = img.alt;
  };

  const leaveVideo = (frame) => {
    const video = frame.querySelector('video.gvideo');
    if (video) { video.pause(); video.hidden = true; }
    frame.classList.remove('is-video');
    const img = frame.querySelector('img');
    img.hidden = false;
    return img;
  };

  const showImage = (frame, button) => {
    const img = leaveVideo(frame);
    remember(img);
    const src = button.dataset.src;
    img.dataset.want = src;
    const next = new Image();
    const apply = () => {
      if (img.dataset.want !== src) return;
      if (next.naturalWidth) { img.width = next.naturalWidth; img.height = next.naturalHeight; }
      if (img.getAttribute('src') !== src) img.src = src;
      img.alt = button.dataset.alt || img.dataset.mainAlt;
    };
    next.onload = apply;
    next.src = src;
    if (next.complete) apply();
  };

  const showVideo = (frame, button) => {
    const img = frame.querySelector('img');
    remember(img);
    const video = videoOf(frame);
    img.dataset.want = '';
    video.style.aspectRatio = (Number(button.dataset.w) || 9) + ' / ' + (Number(button.dataset.h) || 16);
    if (video.getAttribute('src') !== button.dataset.src) {
      video.poster = button.dataset.poster || '';
      video.src = button.dataset.src;
    }
    video.setAttribute('aria-label', button.getAttribute('aria-label') || '');
    frame.classList.add('is-video');
    img.hidden = true;
    video.hidden = false;
    start(video);
  };

  // Picking a colour or gender swaps in that candle's own photo (section script), so leave video mode first.
  const onVariant = (event) => {
    const option = event.target.closest && event.target.closest('[data-variant-images] input[type="radio"]');
    if (!option) return;
    const panel = option.closest('.fixture-panel');
    const thumbs = panel && panel.querySelector('.thumbs');
    if (!thumbs) return;
    const img = leaveVideo(frameOf(thumbs));
    if (img.dataset.mainW) { img.setAttribute('width', img.dataset.mainW); img.setAttribute('height', img.dataset.mainH); }
    setActive(thumbs, null);
  };

  root.addEventListener('click', (event) => {
    const button = event.target.closest('.thumbs .thumb');
    if (!button || !root.contains(button)) { onVariant(event); return; }
    const thumbs = button.closest('.thumbs');
    setActive(thumbs, button);
    if (button.dataset.kind === 'video') showVideo(frameOf(thumbs), button);
    else showImage(frameOf(thumbs), button);
  });
  root.addEventListener('change', onVariant);

  // Switching product (hash change) hides the old panel: stop its video and show its photo again.
  window.addEventListener('hashchange', () => {
    root.querySelectorAll('.gframe.is-video').forEach((frame) => {
      const img = leaveVideo(frame);
      const thumbs = frame.closest('.gallery').querySelector('.thumbs');
      if (!thumbs) return;
      const match = Array.from(thumbs.querySelectorAll('.thumb')).find((thumb) => thumb.dataset.src === img.getAttribute('src'));
      setActive(thumbs, match || null);
    });
  });
})();
